export default __webpack_public_path__ + "static/media/consumer-health.78b96177.jpg";